import script from "./PrimaryBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./PrimaryBtn.vue?vue&type=script&setup=true&lang=js"

import "./PrimaryBtn.vue?vue&type=style&index=0&id=4ed524f8&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ed524f8"]])

export default __exports__